import { ssologion, getUserInfo ,getssoUrl} from '@/api/user'
import { application } from '@/api/date'
import { getdomain,Counsel} from '@/api/home'
import { getToken, setToken, removeToken } from '@/utils/auth'
import router, { resetRouter,asyncRoutes } from '@/router'
import logo from '@/assets/images/logo-new.png'
import defaultSettings from '@/settings'
const state = {
  token: getToken(),
  name: '',
  avatar: '',
  introduction: '',
  roles: [], 
  infonum: 0,
  channelId:'',
  ocurl:'',
  Official:{},
  ssourl:'',
  applicationdata:{},
  channeldata:{}
}

const mutations = {
  SET_SSOURL:(state,ssourl)=>{
    state.ssourl = ssourl
  },
  SET_OCURL:(state,ocurl)=>{
    state.ocurl = ocurl
  },
  SET_OFFICAL:(state,Official)=>{
    state.Official = Official
  },
  SET_INFONUM: (state, infonum) => {
    state.infonum = infonum
  },
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_INTRODUCTION: (state, introduction) => {
    state.introduction = introduction
  },
  SET_NAME: (state, name) => {
    state.name = name
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar
  },
  SET_ROLES: (state, roles) => {
    state.roles = roles
  },
  SET_Id: (state, channelId) => {
    state.channelId = channelId
  },
  SET_APPLICATION:(state, applicationdata) => {
    state.applicationdata = applicationdata
  },
  SET_CHANNEL:(state, channeldata) => {
    state.channeldata = channeldata
  },
}
const actions = {
  getssourl({commit},data){
    return new Promise((resolve, reject) => {
      // data['field'] = 'open'
      getssoUrl(data).then(response => {
        const date = response.data
        if (response.code == 1) {
          commit('SET_SSOURL', date.channel_site[0].domain)
        }
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  ssoLogion({ commit }, data) {
    return new Promise((resolve, reject) => {
      ssologion(data)
        .then(response => {
          const date = response.data
          if (response.code === 1) {
            commit('SET_TOKEN', date.access_token)
            setToken(date.access_token)
          }
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  indexInfo({ commit, state }) {
    return new Promise((resolve, reject) => {
      if(window.location.hostname=='localhost'){
        var ssa = 'www.stbz.net'
      }else{
        var ssa = window.location.host
      }
      const data = {
        domain: ssa,
      }
      Counsel(data)
        .then(async res => {
          let channelId
          if (res.code === 1) {
            let channeldata
            channeldata = res.data
            channelId = res.data.counsel_lst[0].channel_id
            commit('SET_Id', res.data.counsel_lst[0].channel_id)
            console.log(res.data.counsel_lst[0].channel_id,'res.data.counsel_lst[0].channel_id')
            // channelId = defaultSettings.channelId
            // commit('SET_Id', defaultSettings.channelId)
            commit('SET_SSOURL', res.data.login_site.sso_url)
            sessionStorage.setItem('saveTitle', res.data.login_site.title)
            commit('SET_CHANNEL', res.data)
            let params = {
              channel_ids: channelId
            }
        
         await getdomain(params).then(resp=>{
              if(resp.code ===1){
                commit('SET_OCURL', resp.data.Selection?resp.data.Selection.domain:'')
                commit('SET_OFFICAL', resp.data)
              }
            })
          }
          resolve(channelId)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  // get user info
  getInfo({ commit, state }) {
    console.log(state.channelId,'state.channelId')
    return new Promise((resolve, reject) => {
      getUserInfo()
        .then(async(response) => {
          let linkurl = state.ocurl
          asyncRoutes.map(item => {
            if (item.name == '选品平台') {
              item.path = 'http://'+linkurl
            }
          })
          let arr = [
              'applicationmanagement',
              'application',
              'accountmanagement',
              'jibinformation',
              'companyinformation',
              'moneyinfomation',
              'modifyaccount',
              'supgroup',
              'message',
              'messageindex',
              'cooperation', 
              'Associatedcustomer', 
              'Invitecode',
          ]
          let setArr =['set','text','help']
          response.data.push(...setArr)
          if (state.channelId !== 0) {
              let newArr = []
              let rolesArr = ['set']
              for (let i = 0; i < arr.length; i++) {
                for (let j = 0; j < response.data.length; j++) {
                  if (arr[i]==response.data[j]) {
                    newArr.push(arr[i])
                  }

                }
              }
              newArr.push(...rolesArr)
              response.data= []
              response.data.push(...newArr)
            }else{
              if( response.data.length > 0){
                if(response.data.indexOf('applicationmanagement')==-1){
                  let newdata = ['applicationmanagement', 'application','set','text','help']
                  response.data.push(...newdata)
              }
            }
          }
          const data = {
            // 判断账户权限显示菜单【response.data代表返回的权限，返回为空就显示默认权限['applicationmanagement', 'application']】
            roles: response.data.length > 0 ? response.data : ['applicationmanagement', 'application','set','text','help'],
            avatar: await application().then((res) => {
              commit('SET_APPLICATION', res.data)
              let newLogo
              let oldLogo = res.data[0].logo
              if (oldLogo!=='') {
                newLogo=res.data[0].logo
                return newLogo
              }else{
              if (state.channelId!==0) {
                newLogo = logo
              }else{
                newLogo=res.data[0].logo
              }
              return newLogo
              }
            }),
            name: response.data.name,
            introduction: 'qq'
          }
          const { roles, name, avatar, introduction } = data
          // roles must be a non-empty array
          if (!roles || roles.length <= 0) {
            reject('getInfo: roles must be a non-null array!')
          }
          commit('SET_ROLES', roles)
          commit('SET_NAME', name)
          commit('SET_AVATAR', avatar)
          commit('SET_INTRODUCTION', introduction)
          resolve(data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  // user logout
  logout({ commit, state, dispatch }) {
    return new Promise((resolve, reject) => {
      // logout(state.token).then(() => {
      commit('SET_TOKEN', '')
      commit('SET_ROLES', [])
      removeToken()
      resetRouter()

      // reset visited views and cached views
      // to fixed https://github.com/PanJiaChen/vue-element-admin/issues/2485
      dispatch('tagsView/delAllViews', null, { root: true })

      resolve()
    })
  },

  // remove token
  resetToken({ commit }) {
    return new Promise(resolve => {
      commit('SET_TOKEN', '')
      commit('SET_ROLES', [])
      removeToken()
      resolve()
    })
  },

  // dynamically modify permissions
  async changeRoles({ commit, dispatch }, role) {
    const token = role + '-token'

    commit('SET_TOKEN', token)
    setToken(token)

    // const { roles } = await dispatch('user/getInfo')
    // state.roles = await dispatch('getInfo')

    resetRouter()

    // generate accessible routes map based on roles
    const accessRoutes = await dispatch('permission/generateRoutes', {
      root: true
    })
    // dynamically add accessible routes
    router.addRoutes(accessRoutes)

    // reset visited views and cached views
    dispatch('tagsView/delAllViews', null, { root: true })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
